var map = {
	"./views/backtomerchant/back-to-merchant.module": [
		"./src/app/views/backtomerchant/back-to-merchant.module.ts",
		"common",
		"back-to-merchant.module"
	],
	"./views/banktransaction/bank-transaction.module": [
		"./src/app/views/banktransaction/bank-transaction.module.ts",
		"common",
		"bank-transaction.module"
	],
	"./views/customer/customer.module": [
		"./src/app/views/customer/customer.module.ts",
		"common",
		"customer.module"
	],
	"./views/dashboard/dashboard.module": [
		"./src/app/views/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./views/menus/menu.module": [
		"./src/app/views/menus/menu.module.ts",
		"menu.module",
		"common"
	],
	"./views/order/order.module": [
		"./src/app/views/order/order.module.ts",
		"order.module",
		"common"
	],
	"./views/pages/pages.module": [
		"./src/app/views/pages/pages.module.ts",
		"common",
		"pages.module"
	],
	"./views/payment/payment.module": [
		"./src/app/views/payment/payment.module.ts",
		"payment.module",
		"common"
	],
	"./views/paymentbank/bank.module": [
		"./src/app/views/paymentbank/bank.module.ts",
		"common",
		"bank.module"
	],
	"./views/promotion/promotion.module": [
		"./src/app/views/promotion/promotion.module.ts",
		"common",
		"promotion.module"
	],
	"./views/purchase/po.module": [
		"./src/app/views/purchase/po.module.ts",
		"common",
		"po.module"
	],
	"./views/report/report.module": [
		"./src/app/views/report/report.module.ts",
		"report.module",
		"common"
	],
	"./views/saleorder/so.module": [
		"./src/app/views/saleorder/so.module.ts",
		"common",
		"so.module"
	],
	"./views/setting/setting.module": [
		"./src/app/views/setting/setting.module.ts",
		"common",
		"setting.module"
	],
	"./views/testcomponent/test.module": [
		"./src/app/views/testcomponent/test.module.ts",
		"common",
		"test.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main